import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { number, func, string, oneOf, oneOfType, bool } from 'prop-types';
import { Icon } from '@magalu/stereo-ui-icons';
import { Wrapper, Label } from './review.styles';

const Review = _ref => {
  let {
    min,
    max,
    count,
    emptyOutline,
    minCount,
    score = 0,
    format,
    label,
    fontSize,
    onClick
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["min", "max", "count", "emptyOutline", "minCount", "score", "format", "label", "fontSize", "onClick"]);

  const stars = Array.from(Array(max - min).keys());
  const isScoreInteger = Number.isInteger(score);
  const formatByType = {
    count,
    label,
    'score-count': `${score.toFixed(1) || 0} (${count})`
  };
  const showLabel = format === 'label' || count >= minCount;

  const getIcon = (isPlaceHolder, starItem) => {
    const isLastStar = starItem === Math.floor(score);

    if (!isScoreInteger && isLastStar) {
      return 'StarHalf';
    }

    if (!isPlaceHolder && emptyOutline) {
      return 'StarOutline';
    }

    return isPlaceHolder ? 'StarOutline' : 'Star';
  };

  const getColor = () => score === 0 && !emptyOutline ? 'stars.disabled' : 'stars.base';

  const starRatingAriaLabel = `${score.toFixed(1) || 0} de ${max} estrelas, ${count} classificações`;
  return /*#__PURE__*/React.createElement(Wrapper, {
    onClick: onClick,
    "data-testid": "review",
    "aria-label": starRatingAriaLabel
  }, stars.map(i => {
    const isPlaceHolder = score && score <= i;
    return /*#__PURE__*/React.createElement(Icon, _extends({
      name: getIcon(isPlaceHolder, i),
      key: `star-id-${i}`,
      "data-testid": `star-${isPlaceHolder ? 'placeholder' : 'item'}`,
      color: getColor()
    }, props));
  }), showLabel && /*#__PURE__*/React.createElement(Label, {
    format: format,
    fontSize: fontSize
  }, formatByType[format]));
};

process.env.NODE_ENV !== "production" ? Review.propTypes = {
  min: number,
  max: number,
  count: number,
  minCount: number,
  score: number,
  label: string,
  format: oneOf(['count', 'score-count', 'label']),
  fontSize: oneOfType([string, number]),
  onClick: func,
  emptyOutline: bool
} : void 0;
Review.defaultProps = {
  count: 0,
  minCount: 0.1,
  min: 0,
  max: 5,
  score: 0,
  format: 'count',
  emptyOutline: false
};
export default Review;